import api from '~kup/api';
import Advertisement, { AdvertisementType } from '~kup/models/Advertisement.ts';

const COUPON_PATH = {
  ADVERTISEMENTS: () => ['advertisements'].join('/'),
};

export async function getAdvertisements(type: AdvertisementType): Promise<Advertisement[]> {
  const resp = await api.get(COUPON_PATH.ADVERTISEMENTS(), { params: { type } });
  return resp.data.data;
}
